"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HotelView_1 = __importDefault(require("../Other/HotelView"));
const DownloadApp_1 = __importDefault(require("../Other/DownloadApp"));
const BrandTiles_1 = __importDefault(require("../Tiles/BrandTiles"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Imprint_1 = __importDefault(require("../../../common/components/Other/Imprint"));
const NextStayCountDown_1 = __importDefault(require("../../../common/components/Other/NextStayCountDown"));
const BrandScreen = (props) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(HotelView_1.default, null),
    react_1.default.createElement(DownloadApp_1.default, null),
    react_1.default.createElement(NextStayCountDown_1.default, null),
    react_1.default.createElement(BrandTiles_1.default, { tiles: props.brandInfo }),
    react_1.default.createElement(Imprint_1.default, null)));
const mapStoreToProps = (store) => ({
    brandInfo: store.getValue("brandInfo"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(BrandScreen);
